<template>
  <div>
    <b-container fluid="xl">
      <b-row class="justify-content-end">
        <b-col
          md="6"
          cols="10"
          class="overflow-hidden vh-100 d-none d-md-block mr-auto bg-login"
        >
          <img :src="`${publicPath}/img/gep/img-login.svg`" class="img-login" />
          <div class="top-text">
            <div class="fz-28 fw-700">
              {{ $t("Welcome to RCPAY Virtual Account") }}
            </div>
            <div class="fz-28 fw-700">
              {{ $t("Simplifying Your Banking Experience") }}
            </div>
            <!-- <div class="fz-16 fw-400">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div> -->
          </div>
          <div class="bottom-text">
            <!-- <div class="fz-31 fw-700">Welcome to<br />RC365 V Bank</div> -->
            <div class="fz-10 fw-400 mb-1">
              RCPAY Limited is incorporated in the United Kingdom with company
              registration number 12026575.
            </div>
            <div class="fz-10 fw-400">
              RCPAY Limited is the FCA regulated licensed company with license
              number: 917656
            </div>
          </div>
        </b-col>
        <b-col md="4" cols="10" class="minh-100 px-0 mx-auto">
          <div class="d-flex flex-column h-100 justify-content-center">
            <div class="mb-4">
              <div class="fz-31 fw-700 mb-1">{{ $t('Sign Up') }}</div>
              <div class="text-muted fz-16 fw-400">{{ $t('Please fill in the information below') }}</div>
            </div>
            <!-- <hr/> -->
            <validation-observer v-slot="{handleSubmit}" ref="formValidator">
              <b-form role="form" @submit.prevent="handleSubmit(onSubmit)" id="formLogin">
                
                <div class="input-group input-group-alternative mb-3">
                  <div class="input-group-prepend p-2">
                    <img :src="`${publicPath}/img/rcp/icon/mdi_user.png`">
                  </div>
                  <input type="text" class="form-control" v-model="username" name="Username" id="username" :placeholder="$t('Username')" @keydown="onChange('username')" v-uppercase>
                  <div v-if="error.username" class="invalid-feedback d-block mb-3">
                    {{$t(error.username)}}
                  </div>
                </div>

                <div class="mb-3">
                  <base-input alternative
                              name="Email"
                              prepend-icon="ni ni-lock-circle-open"
                              type="text"
                              :placeholder="$t('Email')"
                              v-model="email"
                              @keydown="onChange('email')">
                    <template v-slot:prepend><img :src="`${publicPath}/img/rcp/icon/mdi_email.png`"></template>
                  </base-input>
                  <div v-if="error.email" class="invalid-feedback d-block mb-3">
                    {{$t(error.email)}}
                  </div>
                </div>

                <div class="mb-3">
                  <base-input alternative
                    class="mb-0"
                    id="Password"
                    name="Password"
                    prepend-icon="ni ni-lock-circle-open"
                    :type="show_password?'text':'password'"
                    :placeholder="$t('Password')"
                    v-model="password"
                    @keydown="onChange('password')">
                    <template v-slot:prepend><img :src="`${publicPath}/img/rcp/icon/mdi_password.png`"></template>
                    <template v-slot:append>
                      <a class="btn-action" @click.prevent="toggleShow('password')">
                        <i class="far pl-2 pr-2" :class="{ 'fa-eye-slash': show_password, 'fa-eye': !show_password }"></i>
                      </a>
                    </template>
                  </base-input>
                  <div v-if="error.password" class="invalid-feedback d-block mb-3">
                    {{$t(error.password)}}
                  </div>
                </div>

                <div class="mb-4">
                  <base-input alternative
                    class="mb-4"
                    id="Confirm Password"
                    name="Confirm Password"
                    prepend-icon="ni ni-lock-circle-open"
                    :type="show_password_reconfirm?'text':'password'"
                    :placeholder="$t('Confirm password')"
                    v-model="password_reconfirm"
                    @keydown="onChange('password_reconfirm')">
                    <template v-slot:prepend><img :src="`${publicPath}/img/rcp/icon/mdi_password.png`"></template>
                    <template v-slot:append>
                      <a class="btn-action" @click.prevent="toggleShow('password_reconfirm')">
                        <i class="far pl-2 pr-2" :class="{ 'fa-eye-slash': show_password_reconfirm, 'fa-eye': !show_password_reconfirm }"></i>
                      </a>
                    </template>
                  </base-input>
                  <div v-if="error.password_reconfirm" class="invalid-feedback d-block mb-3">
                    {{$t(error.password_reconfirm)}}
                  </div>
                </div>

                <div class="mb-0">
                  <label :for="agree" id="agree" class="d-flex align-items-center">
                    <input v-model="agree" type="checkbox" checked="" autocomplete="off" @change="onChange('agree')" class="mr-2"/>
                    <span>{{ $t('I agree to RCPAY Virtual Account') }} <a href="term-condition" target="_blank" class="fz-14 fw-400 text-primary">{{ $t('Terms and condition') }}</a></span>
                  </label>
                  <div v-if="error.agree" class="text-danger d-block">
                    {{$t(error.agree)}}
                  </div>
                </div>

                <div class="text-center">
                  <base-button type="primary" pill native-type="submit" class="my-4">{{ $t('Register') }}</base-button>
                  <div class="fz-14 fw-400">{{ $t('Already have an account?') }} <a href="#" @click.prevent="gotoLogin" class="fz-14 fw-400 text-primary"><b>{{ $t('Sign in') }}</b></a></div>
                </div>

              </b-form>
            </validation-observer>
            <div v-if="translation==1" class="change_lang p-4 text-center" id="language">
              <span v-for="(item,index) in language_list" v-if="index!='my-MY'" :key="index">
                <a @click.stop.prevent="setLanguage(index)" :class="'fz-14 '+((current_lang==index)?'active':'')">{{ item }}</a>
              </span>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <LoaderComponent v-if="isLoading"></LoaderComponent>
  </div>
</template>
<script>
  import Auth from "../../services/Auth"
  import ButtonCheckbox from "@/components/ButtonCheckbox";
  import LoaderComponent from "@/components/LoaderComponent";
  import Common from "@/services/Common";

  export default {
    data() {
      return {
        publicPath          :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        translation         : process.env.VUE_APP_TRANSLATION,
        company_logo        : '',
        list_logo           : JSON.parse(process.env.VUE_APP_COMPANY_LOGO),
        username            : '',
        email               : '',
        phone               : '',
        password            : '',
        password_reconfirm  : '',
        current_lang        : '',
        language_list       : [],
        isLoading:false,
        show_password            : false,
        show_password_reconfirm    : false,
        agree               : '',
        error               : {
            username          : '',
            email               : '',
            phone               : '',
            password            : '',
            password_reconfirm  : '',
            agree               : '',
        }
      };
    },
    components : {
      ButtonCheckbox,
      LoaderComponent
    },
    methods: {
      setLanguage(param){
        const lang = param.toLowerCase().replace("-","_");
        localStorage.setItem("lang",lang);
        localStorage.setItem("lang-key",param);
        
        const self = this;
        self.$notify({type: 'success', text: self.getMessage('Successfully change default language')});

        setTimeout(function(){
          location.reload();
        },500);
      },
      getMessage: function (key) {
        return this.$t(key)
      },
      toggleShow(name) {
        this["show_"+name] = !this["show_"+name];
      },
      gotoLogin(){
        this.$router.push({ path: '/login' });
      },
      onChange:function(input){
        this.error[input] = '';
      },
      onSubmit: async function() {
        if(this.agree == true){
          this.isLoading = true;
          const data = { 
            username                : this.username.toUpperCase(), 
            email                   : this.email,
            password                : this.password,
            domain                  : location.protocol+"//"+window.location.hostname,
            // domain                  : "https://gep-api.cgtechnology.io/",
            password_reconfirm      : this.password_reconfirm
          };

          console.log(data);
          
          await Auth.register(data).then(response => {
            if(response.status == 200 && response.data.success){
              this.isLoading = false;
                this.$swal({
                  icon: 'success',
                  html: response.data.message,
                  showConfirmButton: true,
                }).then((result) => {
                  this.$router.push({ path: '/login', query: { "register":"complete" } });
                });
              }
          })
          .catch(err => {
            this.isLoading = false;
            const response = err.response;
            if (typeof err === 'string' || err instanceof String){
              this.$notify({type: 'error', text: 'Oppss.. Something wrong, please contact admin'});
            }       
            else if(response.status == 400){
              Object.keys(response.data.data).forEach((key) => {
                this.error[key] = response.data.data[key][0];
                if(key == "domain"){
                  this.$notify({type: 'error', text: "domain "+location.protocol+"//"+window.location.hostname+" is not allow"});
                }
              });
            }
            else{
              this.error.password = err.message;
            }
          });
        }
        else{
          this.error.agree = "Agreement is required";
        }
      }
    },
    mounted () {
      Object.keys(this.list_logo).forEach((key) => {
        if(window.location.hostname.indexOf(key)!=-1){
          this.company_logo = this.list_logo[key];
        }
      });
      

      if(this.translation==1){
        this.current_lang = localStorage.getItem("lang-key");
        Common.get_language().then(response => {
          if(response.status == 200 && response.data.success){
            this.language_list = response.data.data;
          }
        });
      }
    }
  };
</script>
